import React from "react";
import SearchBar from "@/components/SearchBar";
import SearchableSelect, {
  SearchableSelectOption,
} from "@/components/ui/SearchableSelect";
import type { SearchResponse } from "@/lib/services/searchService";
import { MARKET_COPY } from "@/lib/market/copy";

interface MarketFilterControlsProps {
  locationOptions: SearchableSelectOption[];
  selectedLocation: string;
  onLocationSelect: (location: string) => void;
  onSearch: (query: string) => Promise<SearchResponse>;
  defaultSearchValue: string;
  autoSearch?: boolean;
}

const MarketFilterControls = React.memo(
  ({
    locationOptions,
    selectedLocation,
    onLocationSelect,
    onSearch,
    defaultSearchValue,
    autoSearch = false,
  }: MarketFilterControlsProps) => (
    <div className="w-full flex items-center flex-col lg:flex-row gap-4">
      <div className="w-full">
        <SearchBar
          onSearch={onSearch}
          placeholder={MARKET_COPY.searchPlaceholder}
          defaultValue={defaultSearchValue}
          autoSearch={autoSearch}
        />
      </div>

      <div className="hidden lg:flex flex-wrap w-full lg:w-auto justify-between lg:justify-start gap-2 mt-3 lg:mt-0">
        <div className="relative flex-1 lg:flex-none min-w-[220px]">
          <SearchableSelect
            options={locationOptions}
            value={selectedLocation}
            onChange={onLocationSelect}
            placeholder="Search locations..."
            className="h-10"
          />
        </div>
      </div>
    </div>
  ),
);
MarketFilterControls.displayName = "MarketFilterControls";

export default MarketFilterControls;
